"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var SvgIcon_1 = __importDefault(require("@material-ui/core/es/SvgIcon/SvgIcon"));
var SawbonesIcon = /** @class */ (function (_super) {
    __extends(SawbonesIcon, _super);
    function SawbonesIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SawbonesIcon.prototype.render = function () {
        return (react_1.default.createElement(SvgIcon_1.default, null,
            react_1.default.createElement("svg", null,
                react_1.default.createElement("path", { d: "m 2.1828824,9.4031512 C 0.75347437,8.6820102 0.90547437,8.9283982 0.19856337,6.1866238 -0.07367165,5.1307538 -0.08619765,4.9659728 0.09278535,4.7951248 0.28638837,4.6103218 12.6853,1.0075898 13.127705,1.0075898 c 0.206496,0 0.407489,0.608368 1.573114,4.761523 l 0.316436,1.12747 -1.361106,-0.683034 c -0.820071,-0.411532 -1.360456,-0.6144 -1.359476,-0.510367 9.6e-4,0.09497 0.09119,0.509205 0.200651,0.920529 0.109461,0.411323 0.176874,0.770008 0.149804,0.797078 -0.02707,0.02707 -0.617479,-0.23618 -1.312022,-0.585 -0.694542,-0.34882 -1.286398,-0.610624 -1.315235,-0.581786 -0.02884,0.02884 0.06188,0.464661 0.201584,0.968496 0.13971,0.5038354 0.223659,0.9160644 0.186554,0.9160644 -0.0371,0 -0.6498627,-0.314894 -1.3616856,-0.6997664 -0.711823,-0.384871 -1.319185,-0.674806 -1.349693,-0.644298 -0.03051,0.03051 0.06553,0.453397 0.213414,0.9397524 0.147885,0.486355 0.269354,0.933665 0.26993,0.994022 5.76e-4,0.06036 -0.598169,-0.199229 -1.330545,-0.576856 -0.732376,-0.377629 -1.354538,-0.6636544 -1.382582,-0.63561 -0.02804,0.02804 0.07213,0.486064 0.222617,1.01782 l 0.273605,0.966831 -1.373824,-0.689417 c -0.755603,-0.37918 -1.396253,-0.666987 -1.423667,-0.639574 -0.02741,0.02741 0.07115,0.44777 0.21904,0.934125 0.147885,0.486355 0.269354,0.8997088 0.26993,0.9185648 0.003,0.09664 -0.31575,-0.03784 -1.471666,-0.6210058 z M 15.797386,6.5958038 c -0.405337,-1.274007 -0.450651,-1.603806 -0.229188,-1.668034 0.123073,-0.03569 0.578602,-0.165336 1.012289,-0.288093 0.512868,-0.145172 0.788521,-0.295521 0.788521,-0.430085 0,-0.482867 -0.628509,-2.239576 -0.801699,-2.24078 -0.101527,-6.86e-4 -0.521368,0.09662 -0.932981,0.216278 -0.411613,0.11966 -0.826438,0.187611 -0.921836,0.151003 -0.157117,-0.06029 -0.585946,-1.56419098 -0.475501,-1.66757798 0.139505,-0.13059 2.061278,-0.620864 2.433657,-0.620864 1.081482,0 1.702061,0.67799 2.215451,2.42040498 0.466295,1.582575 0.495753,2.141133 0.147292,2.79283 -0.317072,0.592997 -0.81512,0.891937 -2.061385,1.237295 -1.148398,0.318238 -1.105562,0.314677 -1.17462,0.09762 z" }))));
    };
    return SawbonesIcon;
}(react_1.Component));
exports.default = SawbonesIcon;



//////////////////
// WEBPACK FOOTER
// ./src/components/icons/SawbonesIcon.tsx
// module id = 794
// module chunks = 0